import { render, staticRenderFns } from "./FreshChatMessages.vue?vue&type=template&id=95883c4a&scoped=true"
import script from "./FreshChatMessages.vue?vue&type=script&lang=js"
export * from "./FreshChatMessages.vue?vue&type=script&lang=js"
import style0 from "./FreshChatMessages.vue?vue&type=style&index=0&id=95883c4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95883c4a",
  null
  
)

export default component.exports